import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from "../../helpers";
import { RouterModule, Router, NavigationEnd } from '@angular/router'
import { MainService } from '../../portal/service/main.service';
import { ProfileService } from '../../portal/service/profile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { session } from '../../../environments/environment.session'
import { SpinnerService } from '../../shared/spinner.service'
import { DataControlService } from '../service/data-control.service';
import { en } from '../../../environments/environment.tok'
import { DecryptService } from '../../decrypt.service'
import { AuthenticationService } from '../../authentication.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-sdp-layouts',
  templateUrl: './sdp-layouts.component.html',
  styleUrls: ['./sdp-layouts.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SdpLayoutsComponent implements AfterViewInit {
  codeValueObj = {};
  codeValueTechObj = {};
  codeValueShowObj = {};
  codeValueShowTempObj = {};
  b_acct_id: any;
  erpUser: any;
  empObj: any = {}
  is_side_bar = false
  constructor(private dataControlService: DataControlService, private tSpinner: SpinnerService, private sanitizer: DomSanitizer, private snackBar: MatSnackBar, private profileService: ProfileService, public mainService: MainService, private router: Router, private decrypt: DecryptService, private auth: AuthenticationService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.mainService.isMobileSidebarOpen) {
          this.mainService.isMobileSidebarOpen = false;
        }
      }
    });
  }

  async ngOnInit() {
    this.tSpinner.show('', '')
    if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
      if (session.erpUser == undefined || session.erpUser == null) {
        this.router.navigate(['/login']);
      }
    } else {
      try {
        this.erpUser = JSON.parse(atob(session.erpUser));;
        this.b_acct_id = this.erpUser.b_acct_id;
        this.gon = true
      } catch (err) {
        en.temppu = await this.decrypt.decryptUsingAES256(en.temppu)
        en.temppa = await this.decrypt.decryptUsingAES256(en.temppa)
        await this.getErpUser()
      }
    }



    // if(this.erpUser.role_cd.includes('AA')){
    //   this.is_side_bar=true
    // }
    await this.getCodeValue()
    // await this.getAllTaskOfUser()
    // await this.mainService.getAllLanguage()
    // await this.mainService.getAllLabel({component_cd:null,module_cd:['MD']});
    await this.mainService.getHeaderInfo(this.b_acct_id)
    // this.router.navigate(['cfc/birth']);

  }





  gon: boolean = false
  async getErpUser() {
    let obj = {}
    let resp = await this.auth.getErpUser((obj))
    if (resp['error'] == false) {
      this.erpUser = JSON.parse(resp['data'][0]['erpUser'])
      session.erpUser = btoa(resp['data'][0]['erpUser'])
      this.gon = true
    } else {
      Swal.fire('Error', resp['data'], 'error')
    }
  }

  async getAllTaskOfUser() {
    var obj: any = Object()
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['user_id'] = this.erpUser.user_id
    obj["status"] = 'PENDING'
    console.log(obj)
    var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj))
    if (resp['error'] == false) {
      console.log(resp['data'])
      this.mainService.count = resp.pendingFiles
    } else {

    }
  }



  async getCodeValue() {

    var resp = await this.mainService.getCodeValue(this.b_acct_id || 90);
    console.log(resp);
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.codeValueObj = codeValueTempObj;
      this.codeValueShowObj = codeValueShowTempObj;
      this.mainService.codeValueTechObj = this.codeValueObj;
      this.mainService.codeValueShowObj = this.codeValueShowObj;
      console.log(this.codeValueObj);
      console.log(this.codeValueShowObj);
    } else {

    }

  }
  ngAfterViewInit() {

    // initialize layout: handlers, menu ...
    Helpers.initLayout();

  }
  async getEmpInfo() {
    var resp = await this.profileService.getUserProfileInfo(this.erpUser.user_id);
    if (resp['error'] == false) {
      this.empObj = resp['data'][resp['data'].length - 1];
    } else {
      this.snackBar.open(resp['data'], 'Error', {
        duration: 5000,
      });
    }

  }
  async getEstablishmentInfo() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    obj['email'] = this.empObj['email'];
    obj['phone_no'] = this.empObj['work_phone_no'];
    var resp: any = await this.profileService.getEstablishmentInfo(JSON.stringify(obj));
    if (resp['error'] == false) {
      if (resp['data'].length > 0) {
        var dt = resp['data'][0];
        this.mainService.emp_id = dt['emp_id'];
        this.mainService.personalInfoObj = dt;

      }

    } else {

    }
  }

}


